/**
 * Formattazione per le persone, in italiano.
 *
 * Gli istanti arrivano dal server in UTC e vengono resi nel fuso dell'evento:
 * un orologio da polso italiano, non l'ora di Greenwich. La stessa conversione
 * la fa il server per il file Excel, quindi foglio e schermo dicono la stessa
 * ora — che è l'unica cosa che conta quando si confrontano.
 */
import {
  DEFAULT_TIME_ZONE,
  formatDateIt,
  formatDateTimeIt,
  formatIsoDateIt,
  formatPercentIt,
  formatTimeIt,
} from '@pietrochip/shared';

export const APP_TIME_ZONE = DEFAULT_TIME_ZONE;

/** `14:32` — l'ora che interessa al banco. */
export function time(value: string | null | undefined): string {
  return value ? formatTimeIt(value, APP_TIME_ZONE) : '—';
}

/** `02/10/2026` */
export function date(value: string | null | undefined): string {
  return value ? formatDateIt(value, APP_TIME_ZONE) : '—';
}

/** `02/10/2026, 14:32` */
export function dateTime(value: string | null | undefined): string {
  return value ? formatDateTimeIt(value, APP_TIME_ZONE) : '—';
}

/** `2026-10-02` → `2 ottobre 2026` */
export function eventDate(isoDate: string | null | undefined): string {
  return formatIsoDateIt(isoDate) || '';
}

/** `0.5` → `50,0%` */
export function percent(fraction: number, digits = 1): string {
  return formatPercentIt(fraction, digits);
}

/** Nome e cognome, saltando i pezzi mancanti. */
export function personName(
  firstName: string | null | undefined,
  lastName: string | null | undefined,
): string {
  const parts = [lastName, firstName].filter((part): part is string => Boolean(part?.trim()));
  return parts.length > 0 ? parts.join(' ') : '—';
}

/** Data e ora in formato `datetime`, per l'attributo `title`. */
export function titleDateTime(value: string | null | undefined): string | undefined {
  return value ? dateTime(value) : undefined;
}
